import Script from 'next/script';
import { disableHotjar, getHotjarBootstrapScript } from '@/lib/analytics/hotjar/client';
import { useHotjarEnabled } from '@/lib/analytics/hotjar/useHotjarEnabled';
import { useConsentHandler } from '@/lib/consent';

/** Renders the Hotjar bootstrap snippet while consent allows it, and tears it down otherwise. */
const HotjarScript = () => {
  useConsentHandler('hotjar', ({ allowed }) => {
    if (!allowed) {
      disableHotjar();
    }
  });

  const hotjarEnabled = useHotjarEnabled();
  const bootstrapScript = hotjarEnabled ? getHotjarBootstrapScript() : null;

  if (!bootstrapScript) {
    return null;
  }

  return (
    <Script id="add-hotjar" strategy="lazyOnload">
      {bootstrapScript}
    </Script>
  );
};

export default HotjarScript;
